import type { ReactNode } from "react";

import { cn } from "@/lib/utils";

/** Permanent Marker product name inside a hero title, with an optional mark. */
export function BrandLockup({
  children,
  mark,
  className,
}: {
  children: ReactNode;
  mark?: "®" | "TM";
  className?: string;
}) {
  return (
    <span
      className={cn(
        "relative inline-block whitespace-nowrap pr-[0.27em] font-permanent-marker text-[1.1em] font-normal normal-case leading-[0.9] tracking-[-0.025em] text-teal-500",
        className,
      )}
    >
      {children}
      {mark && (
        <sup className="absolute right-0 top-[0.04em] m-0 font-figtree text-[0.23em] font-extrabold leading-none tracking-normal">
          {mark}
        </sup>
      )}
    </span>
  );
}

/** Smaller line under a BrandLockup. */
export function HeroSubtitle({ children }: { children: ReactNode }) {
  return (
    <span className="inline-block text-[clamp(38px,5vw,64px)] leading-[1.02] tracking-[-0.045em]">
      {children}
    </span>
  );
}

export function PatentBadge() {
  return (
    <div className="absolute left-1/2 top-12 z-[3] inline-flex min-h-[27px] -translate-x-1/2 rotate-1 items-center rounded-[7px] border border-[rgba(37,217,207,0.48)] bg-[rgba(37,217,207,0.14)] px-[10px] font-figtree text-[10px] font-extrabold uppercase leading-none tracking-[0.1em] text-[#B9FFF5]">
      Patent pending
    </div>
  );
}
